import React from 'react'
import { useState,useEffect,useContext, useRef } from 'react';
 
import Moment from 'react-moment';
import Select from 'react-select';
import cogoToast from "cogo-toast";
import { FaSearch, FaSpinner, FaTimesCircle } from "react-icons/fa";

import {  getList,postList,genericPost, genericGet } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, BASE_URL } from "../../../Constants";
import AppContext from "../../../AppContext";
import { PulseLoader } from "react-spinners";
import { useLocation, useHistory } from "react-router-dom";

import Calendar, {
    Appointment,
    logSelectedDatesAppointments,
  } from "react-multi-date-picker-calendar";
import { Spinner } from 'react-bootstrap';
import { Alert, Badge, Label } from 'reactstrap';
import { EbmsLoading, getListStaffDetailsRequestBody, getLoggedInStaffAccountId, normalizeLeaveDocuments } from '../../../services/Utils';
import LeaveDocumentList from "./LeaveDocumentList";
  // import "react-multi-date-picker-calendar/dist/calendar.css";

const parseApiErrors = (payload, fallback = "Request failed. Please try again.") => {
  if (!payload) return [fallback];
  const errors = [];

  const pushMessage = (value) => {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach((item) => pushMessage(item));
      return;
    }
    if (typeof value === "object") {
      Object.values(value).forEach((item) => pushMessage(item));
      return;
    }
    const text = String(value).trim();
    if (text) errors.push(text);
  };

  pushMessage(payload.message);
  pushMessage(payload.errors);
  pushMessage(payload.data);

  return errors.length > 0 ? Array.from(new Set(errors)) : [fallback];
};

const normalizeId = (value) => {
  if (value === null || value === undefined || value === "") return null;
  return String(value);
};

const parseLeaveDays = (daysRaw) => {
  try {
    if (!daysRaw) return [];
    const parsed = typeof daysRaw === "string" ? JSON.parse(daysRaw) : daysRaw;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((day) => {
        const text = String(day).trim();
        const match = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
          return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
        }
        const date = new Date(text);
        return Number.isNaN(date.getTime()) ? null : date;
      })
      .filter(Boolean);
  } catch {
    return [];
  }
};

const CreateLeave = () => {
  const global = useContext(AppContext);
  const location = useLocation();
  const history = useHistory();
  const editLeaveFromState =
    location?.state?.editLeave ||
    location?.state?.leave ||
    null;
  const editLeaveId =
    location?.state?.request_id ||
    editLeaveFromState?.id ||
    null;
  const isEditMode = Boolean(editLeaveId);

  const [IsLoading, setIsLoading] = useState(false)
const [leave_reason, setLeave_reason] = useState("")
    const [selectedDates, setSelectedDates] = useState([]);
    const [leave_type, setLeave_type] = useState(null)
    const [activeClaim, setActiveClaim] = useState(null)

    
    const [leave_types, setLeave_types] = useState([]);
const [staff_code, setstaff_code] = useState("")
const [staff_data, setstaff_data] = useState(null)
const [users, setUsers] = useState([])
const [hrStaffUsers, setHrStaffUsers] = useState([])

const [supervisor, setSupervisor] = useState(null)
const [hr_staff, setHr_staff] = useState(null)
const [handover_staff, setHandover_staff] = useState(null)
const [handover_completed, setHandover_completed] = useState(false)
const [handover_note_file, setHandover_note_file] = useState([])
const [medical_report_file, setMedical_report_file] = useState([])

const [activeClaims, setActiveClaims] = useState([])
const [pageErrors, setPageErrors] = useState([]);
const [existingDocuments, setExistingDocuments] = useState([]);
const [isPrefilling, setIsPrefilling] = useState(false);
const [calendarKey, setCalendarKey] = useState(0);
const errorAlertRef = useRef(null);

 

const convert_date=(m)=>{
    var date = new Date(m);  
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
        
    let formatted=`${year}-${month}-${day}`; 
    return formatted;
}

useEffect(() => {
  const init = async () => {
    const types = await listLeaveTypes();
    const { allUsers, role2Users } = await listUsers();
    const claims = await listActiveClaims();

    if (isEditMode && editLeaveId) {
      await loadLeaveForEdit(editLeaveId, {
        types,
        allUsers,
        hrUsers: role2Users,
        claims,
      }, editLeaveFromState);
      return;
    }

    const staffRequest = getListStaffDetailsRequestBody(global.get_logged_in_user());
    if (staffRequest) {
      load_staff_details(staffRequest);
    } else {
      showPageErrors(["Staff ID not found on your profile. Please contact HR or sign in again."]);
    }
  };

  init();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [editLeaveId]);

useEffect(() => {
  if (pageErrors.length > 0) {
    errorAlertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, [pageErrors]);

const clearPageErrors = () => setPageErrors([]);

const showPageErrors = (errors) => {
  const normalized = Array.isArray(errors) ? errors.filter(Boolean) : [errors].filter(Boolean);
  setPageErrors(normalized.length > 0 ? normalized : ["Something went wrong. Please try again."]);
};

const listUsers = async () => {
  setIsLoading(true);
  const [allUsers, role2Users] = await Promise.all([
    getList(ENDPOINTS.LIST_USERS),
    getList(`${ENDPOINTS.LIST_USERS}?role=2`),
  ]);
  setUsers(allUsers);
  setHrStaffUsers(role2Users);
  setIsLoading(false);
  return { allUsers, role2Users };
};

const listActiveClaims = async () => {
  const claims = await getList(ENDPOINTS.ACTIVE_CLAIMS);
  setActiveClaims(claims);
  return claims;
};

const findUserOption = (userList, userId) => {
  const normalizedId = normalizeId(userId);
  if (!normalizedId || !Array.isArray(userList)) return null;
  const match = userList.find((u) => normalizeId(u.value) === normalizedId);
  return match ? { value: match.value, label: match.text } : null;
};

const resolveLeaveTypeOption = (leave, types = []) => {
  const leaveTypeId = leave?.leave_type_id || leave?.leave_type?.id;
  const normalizedLeaveTypeId = normalizeId(leaveTypeId);
  if (!normalizedLeaveTypeId) return null;

  const matchedLeaveType = types.find(
    (type) => normalizeId(type.id) === normalizedLeaveTypeId
  );
  if (matchedLeaveType) {
    return {
      value: matchedLeaveType.id,
      label: matchedLeaveType.name,
      id: matchedLeaveType.id,
      max_days: matchedLeaveType.max_days,
      details: matchedLeaveType?.details,
      remaining_days: matchedLeaveType.remaining_days,
    };
  }

  if (leave?.leave_type?.name) {
    return {
      value: leaveTypeId,
      label: leave.leave_type.name,
      id: leaveTypeId,
      details: leave.leave_type?.details,
    };
  }

  return {
    value: leaveTypeId,
    label: "Selected leave type",
    id: leaveTypeId,
  };
};

const applyStaffPrefill = (leave) => {
  if (leave?.staff) {
    setstaff_data({
      staff_code: leave.staff_id || leave.staff?.staff_code,
      email: leave.staff?.email,
      telephone: leave.staff?.telephone,
      gender: leave.staff?.gender,
      passport: leave.staff?.passport,
      blood_group: leave.staff?.blood_group,
    });
    return;
  }

  if (leave?.staff_id) {
    find_staff_by_code(leave.staff_id);
  }
};

const applyLeavePrefill = (leave, lists = {}) => {
  if (!leave) return;

  const types = lists.types || leave_types;
  const allUsers = lists.allUsers || users;
  const hrUsers = lists.hrUsers || hrStaffUsers;
  const claims = lists.claims || activeClaims;

  setLeave_reason(leave.leave_reason || "");
  const parsedDates = parseLeaveDays(leave.days);
  setSelectedDates(parsedDates);
  setCalendarKey((key) => key + 1);

  const leaveTypeOption = resolveLeaveTypeOption(leave, types);
  if (leaveTypeOption) {
    setLeave_type(leaveTypeOption);
  }

  const supervisorId = leave.supervisor_id || leave.supervisor?.id;
  const hrId = leave.hr_id || leave.hr?.id;
  const handoverId =
    leave.handover_to ||
    leave.handover_to_id ||
    leave.handedover_to?.id ||
    leave.handedover_to?.user_id;

  const supervisorOption = findUserOption(allUsers, supervisorId);
  const hrOption = findUserOption(hrUsers, hrId) || findUserOption(allUsers, hrId);
  const handoverOption = findUserOption(allUsers, handoverId);

  if (supervisorOption) setSupervisor(supervisorOption);
  if (hrOption) setHr_staff(hrOption);
  if (handoverOption) {
    setHandover_staff(handoverOption);
    setHandover_completed(true);
  } else if (handoverId) {
    setHandover_completed(Boolean(leave.handover) || leave.handover === "1" || leave.handover === 1);
  }

  if (leave.toil_id && Array.isArray(claims)) {
    const matchedClaim = claims.find(
      (claim) => normalizeId(claim.id) === normalizeId(leave.toil_id)
    );
    if (matchedClaim) {
      setActiveClaim({ value: matchedClaim.id, label: matchedClaim.subject });
    }
  }

  setExistingDocuments(normalizeLeaveDocuments(leave));
};

const loadLeaveForEdit = async (requestId, lists, routeLeave = null) => {
  setIsPrefilling(true);
  try {
    if (routeLeave) {
      applyLeavePrefill(routeLeave, lists);
      applyStaffPrefill(routeLeave);
      clearPageErrors();
    }

    const res = await genericGet(`${ENDPOINTS.LEAVE_DETAILS}/${requestId}`);
    if (res?.status === 200 && res?.data?.status === SUCCESS_RESULT) {
      const leave = { ...(routeLeave || {}), ...(res.data.data || {}) };
      applyLeavePrefill(leave, lists);
      applyStaffPrefill(leave);
      clearPageErrors();
      return;
    }

    if (!routeLeave) {
      showPageErrors(parseApiErrors(res?.data, "Failed to load leave request for editing."));
    }
  } catch (err) {
    if (!routeLeave) {
      showPageErrors(parseApiErrors(err?.response?.data, "Failed to load leave request for editing."));
    }
  } finally {
    setIsPrefilling(false);
  }
};


const load_staff_details = (requestBody) => {
  if (!requestBody || (!requestBody.staff_code && !requestBody.staff_id)) {
    showPageErrors(["Staff ID is required to load staff details."]);
    return;
  }

  setIsLoading(true);
  genericPost(ENDPOINTS.LIST_STAFF_DETAILS, requestBody)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setstaff_data(res.data["data"]);
          clearPageErrors();
        } else {
          showPageErrors(parseApiErrors(res.data, "Failed to load staff details."));
        }
      } else {
        showPageErrors(["Connection error. Please try again."]);
      }
      setIsLoading(false);
    })
    .catch((err) => {
      setIsLoading(false);
      showPageErrors(parseApiErrors(err?.response?.data, "Critical error occurred. Please try again."));
    });
};

const find_staff_by_code = (staff_id) => {
  if (!staff_id) {
    showPageErrors(["Staff ID is required to load staff details."]);
    return;
  }

  load_staff_details({ staff_code: String(staff_id).trim() });
};

const validateLeaveForm = () => {
  const errors = [];

  if (selectedDates.length < 1) {
    errors.push("Please select at least one leave day.");
  }
  if (leave_type?.label?.toString().includes("TOIL") && activeClaim == null) {
    errors.push("Please select a TOIL claim for this leave type.");
  }
  if (!leave_type?.id) {
    errors.push("Please select a leave type.");
  }
  if (!leave_reason || leave_reason.trim().length < 10) {
    errors.push("Leave reason must be at least 10 characters.");
  }
  if (!supervisor?.value) {
    errors.push("Please select a supervisor.");
  }
  if (!hr_staff?.value) {
    errors.push("Please select HR staff.");
  }
  if (!handover_staff?.value) {
    errors.push("Please select handover staff.");
  }
  if (!handover_completed) {
    errors.push("Please confirm handover delegation by checking the handover box.");
  }

  return errors;
};

const createLeave=(e)=>{
e?.preventDefault(); 

const validationErrors = validateLeaveForm();
if (validationErrors.length > 0) {
  showPageErrors(validationErrors);
  return;
}

clearPageErrors();
let formatted_dates=[];
selectedDates.forEach((d)=>{
  formatted_dates.push(convert_date(d));
})
setIsLoading(true)

  let form_data = new FormData(e.target);
  
  form_data.append('staff_id', getLoggedInStaffAccountId(global.get_logged_in_user()));
  form_data.append('leave_type_id',leave_type?.id)
  form_data.append('total_days',formatted_dates.length,)
  form_data.append('dates', JSON.stringify(formatted_dates))
  form_data.append('leave_reason',leave_reason)
form_data.append('supervisor_id',supervisor?.value)
form_data.append('hr_id',hr_staff?.value)
form_data.append('handover',1)
form_data.append('handover_to',handover_staff?.value)
if(activeClaim!=undefined &&activeClaim?.value!=undefined&&activeClaim?.value!=null&&activeClaim?.value!="")
form_data.append('toil_id',activeClaim?.value)

if (isEditMode && editLeaveId) {
  form_data.append("request_id", editLeaveId);
}
  
  genericPost(ENDPOINTS.CREATE_LEAVE,form_data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        global.show_operation_result({
          success: true,
          message: isEditMode ? "Leave request updated successfully" : "Leave Form submitted Successfully",
        });
        clearPageErrors();
        cogoToast.success(responseData.message);
        if (isEditMode) {
          history.push("/hrm/leave/my-leave-requests");
        }
        }
      else
      {
        showPageErrors(parseApiErrors(responseData, isEditMode ? "Failed to update leave request." : "Failed to submit leave request."));
      }
      } else {
        showPageErrors(parseApiErrors(res.data, isEditMode ? "Failed to update leave request." : "Failed to submit leave request."));
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    showPageErrors(parseApiErrors(err?.response?.data, err?.message || (isEditMode ? "Failed to update leave request." : "Failed to submit leave request.")));
    console.log(err);
  });

}
const listLeaveTypes=async ()=>{
  setIsLoading(true);
  const types = await getList(ENDPOINTS.LEAVE_TYPES);
  setLeave_types(types);
  setIsLoading(false);
  return types;
} 

const getMinDate=()=>{
  try{
  var date = new Date();
 

 

return  date.setDate(date.getDate() - 1) ;
  }catch(e){alert(e)}
//.addDays(-1);
 
}

const handleDateChange = (dates) => {
   
    
    setSelectedDates(dates);
  };
  return (
    <div className="page-wrapper">
 
       
 
        <div className="page-body">
          <div className="container-xl">
            <div className="card shadow-sm border-0">
            
             
              <div className="card-header" style={{ background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", color: "white" }}>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                  <div>
                    <h3 className="mb-0" style={{ color: "white", fontWeight: 700 }}>
                      {isEditMode ? "Edit Leave Request" : "Leave Request"}
                    </h3>
                    <small style={{ opacity: 0.9 }}>
                      {isEditMode
                        ? "Update your leave details and re-upload documents if needed"
                        : "Fill in the details and submit for approval"}
                    </small>
                  </div>
                </div>
              </div>
                  
                   
               
                  <div className="card-body" style={{ padding: "1rem" }}>
                  {/* <div className="input-group">

                                <input type="text"   styles={{width:"200px"}} onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                <button className="btn -btnprimary" type="button" onClick={()=>find_staff_by_code(staff_code)}><FaSearch style={{color:"white"}}></FaSearch> </button>
                              </div> */}

<div className="card border-0 shadow-sm mb-3">
  <div className="card-body" style={{ padding: "0.9rem" }}>
    {staff_data ? (
      <div className="row g-2" style={{ fontSize: "0.9rem" }}>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Staff Code</div>
          <div style={{ fontWeight: 700 }}>{staff_data?.staff_code || "-"}</div>
        </div>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Email</div>
          <div className="text-truncate" title={staff_data?.email || ""}>{staff_data?.email || "-"}</div>
        </div>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Phone</div>
          <div style={{ fontWeight: 600 }}>{staff_data?.telephone || "-"}</div>
        </div>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Gender</div>
          <div style={{ fontWeight: 600 }}>{staff_data?.gender || "-"}</div>
        </div>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Passport</div>
          <div style={{ fontWeight: 600 }}>{staff_data?.passport || "-"}</div>
        </div>
        <div className="col-md-3 col-6">
          <div className="text-muted" style={{ fontSize: "0.75rem" }}>Blood Group</div>
          <div style={{ fontWeight: 600 }}>{staff_data?.blood_group || "-"}</div>
        </div>
      </div>
    ) : (
      <div className="text-center py-3">
        {isPrefilling ? <PulseLoader /> : <span className="text-muted">Loading staff details...</span>}
      </div>
    )}
  </div>
</div>

                     <form onSubmit={createLeave}>

                    
                   <div className='row g-3'>
                    <div className='col-lg-4 col-md-6'>
                      <Label style={{ fontWeight: 700 }}>Leave Type</Label>
                      <Select
styles={{width:"80%"}}
        value={leave_type}
         onChange={setLeave_type}
        options= {leave_types?.map((u)=>{  
          return { value: u.id, label: u.name  ,id:u.id,max_days:u.max_days,details:u?.details,remaining_days:u.remaining_days }  
          })}
      />
 
{leave_type?.label.toString().includes("TOIL") &&
 <>
 Select Toil Claim
 <Select
styles={{width:"80%"}}
        value={activeClaim}
         onChange={setActiveClaim}
        options= {activeClaims?.map((u)=>{  
          return { value: u.id, label: u.subject }  
          })}
      />
 </>
}

 
 

 
      <div className="mt-2" style={{ fontSize: "0.85rem" }}>
        <b>Balance:</b> {leave_type?.label || "-"} • <b>{leave_type?.remaining_days ?? "-"} day(s)</b>
      </div>
      {/* {JSON.stringify(leave_type)} */}

                        
                        <Label className="mt-2" style={{ fontWeight: 700 }}>Select Days</Label>
                        {isPrefilling ? (
                          <div className="py-2 text-muted" style={{ fontSize: "0.85rem" }}>
                            <PulseLoader size={8} /> Loading selected days...
                          </div>
                        ) : (
                        <Calendar
                        key={calendarKey}
                        minDate={getMinDate()}
            weekdayFormat={1}
            multiSelect={true}
            numberOfMonths={2}
            monthsToShow={2}
            value={selectedDates}
            handleOnChange={handleDateChange}
            OnChange={handleDateChange}
          />
                        )}

          <div className="mt-2" style={{ fontSize: "0.95rem" }}>
            Number of Days Requested: <b>{selectedDates.length}</b>
          </div>
                {/* <ol> 
                  {  selectedDates.map((d)=>{
                      return  <li> {convert_date(d)} </li>
                  })}
                  </ol> */}
                    <br/>
                    
                    </div>
                    <div className='col-lg-4 col-md-6'>
                        <Label style={{ fontWeight: 700 }}>
                          Leave Reason <span className="text-danger">*</span>
                        </Label>
                        <textarea
                          rows={8}
                          className='form-control'
                          value={leave_reason}
                          onChange={(e)=>setLeave_reason(e.target.value)}
                          placeholder="Explain the reason for your leave (minimum 10 characters)"
                          style={{ fontSize: "0.9rem" }}
                        />
                        <div className="d-flex justify-content-between mt-1" style={{ fontSize: "0.8rem" }}>
                          <span className={leave_reason.trim().length >= 10 ? "text-success" : "text-muted"}>
                            {leave_reason.trim().length}/10 min chars
                          </span>
                          {leave_reason.trim().length > 0 && leave_reason.trim().length < 10 && (
                            <span className="text-danger">Too short</span>
                          )}
                        </div>


{/* {JSON.stringify(leave_types)} */}


 <Label className="mt-2" style={{ fontWeight: 700 }}>Supervisor</Label>
 <Select
        value={supervisor}
         onChange={setSupervisor}
        options= {users?.map((u)=>{  
          return { value: u.value, label: u.text }  
          })}
      />

<Label className="mt-2" style={{ fontWeight: 700 }}>HR Staff</Label>
<Select
        value={hr_staff}
         onChange={setHr_staff}
        options={hrStaffUsers?.map((u) => ({
          value: u.value,
          label: u.text,
        }))}
      />
<div className="mt-2" />



                       



                    </div>

                    <div className='col-lg-4 col-md-12'>
                      <div className="card border-0 shadow-sm" style={{ padding: "0.9rem" }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <Label style={{ fontWeight: 700, margin: 0 }}>Handover Delegation</Label>
                      <div className="form-check m-0">
                        <input
                          className="form-check-input"
                          type='checkbox'
                          required={!isEditMode}
                          checked={handover_completed}
                          onChange={(e)=>setHandover_completed(e.target.checked)}
                          id="handoverCompleted"
                        />
                        <label className="form-check-label" htmlFor="handoverCompleted" style={{ fontSize: "0.9rem" }}>
                          Yes
                        </label>
                      </div>
                    </div>

 
<div className="mt-2" />
{handover_completed && <>
<Label style={{ fontWeight: 700 }}>Delegated To (Employee)</Label>
<Select
 required={true} 
        value={handover_staff}
         onChange={setHandover_staff}
        options= {users?.map((u)=>{  
          return { value: u.value, label: u.text }  
          })}
      />
      </>}

 
<div className="mt-3" />
  <Label style={{ fontWeight: 700 }}>Upload Documents</Label>
  {isEditMode && existingDocuments.length > 0 && (
    <div className="mb-2" style={{ fontSize: "0.85rem" }}>
      <div className="text-muted mb-2">Current documents (upload new files below to replace):</div>
      <LeaveDocumentList documents={existingDocuments} emptyText="No documents uploaded." />
    </div>
  )}
 
 
{ leave_type?.details?.documents!=null &&  leave_type?.details.documents?.map((file,i)=>{
  return <b key={file.id || i}> {i+1} - {file.title}
  <input
            type="file"
            name={file.id}
          accept=".pdf, .doc, .docx"
            required={!isEditMode}
           
            onChange={(e)=>  setHandover_note_file(e.target.files) } /> 
            <br/>
  </b>
})}


 
     



<div className="mt-3" />
                      {pageErrors.length > 0 && (
                        <div ref={errorAlertRef} className="mb-3">
                          <Alert
                            color="danger"
                            className="mb-0 shadow-sm"
                            style={{
                              border: "1px solid #f5c2c7",
                              borderLeft: "5px solid #dc3545",
                              backgroundColor: "#fff5f5",
                            }}
                          >
                            <div className="d-flex align-items-start gap-3">
                              <FaTimesCircle size={22} className="text-danger flex-shrink-0 mt-1" />
                              <div className="flex-grow-1">
                                <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#842029", marginBottom: "0.5rem" }}>
                                  Please fix the following issues
                                </div>
                                <ul className="mb-0 ps-3" style={{ fontSize: "0.95rem", color: "#58151c", lineHeight: 1.5 }}>
                                  {pageErrors.map((error, index) => (
                                    <li key={`${error}-${index}`} style={{ marginBottom: "0.35rem" }}>
                                      {error}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <button
                                type="button"
                                className="btn-close"
                                aria-label="Dismiss errors"
                                onClick={clearPageErrors}
                              />
                            </div>
                          </Alert>
                        </div>
                      )}
      <button
        type='submit'
        disabled={
          staff_data==null ||
          leave_type==null ||
          selectedDates?.length < 1 ||
          IsLoading==true ||
          isPrefilling ||
          !supervisor?.value ||
          !hr_staff?.value ||
          !handover_staff?.value
        }
        className="btn btn-primary btn-lg"
        style={{ width:"100%", background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", border: "none" }}
      >
        {IsLoading ? (
          <> <FaSpinner icon="spinner" className="spinner" /> &nbsp;&nbsp; Processing </>
        ) : (
          <b>{isEditMode ? "Update Leave" : "Create Leave"}</b>
        )}
      </button>
      </div>

                      </div>


                   </div>
                 


                  </form>
                  
 

                  </div>
  
 
 
                   
           
              </div>
            </div>
          </div>
        </div>
       
     
  )
}

export default CreateLeave